import { getCscEntityPrefix } from '../../../config/Config';
import { OUTLIER_DEFINITIONS } from '../types/types';

export const MAX_ITEMS_PER_PAGE = 7;
export const ZERO_TOLERANCE_PRIORITY_BOOST = 1000000;
export const MAX_THUMBNAIL_DISPLAY = 5;
export const NUM_WEEKS_FOR_OUTLIERS = 52;
export const OM_FILTER_MAX_NUM_WEEKS = 4;

export const BACKEND_CATEGORY_MAP = {
  rudeness: OUTLIER_DEFINITIONS.RUDENESS,
  background_noise: OUTLIER_DEFINITIONS.BACKGROUND_NOISE,
  high_silence: OUTLIER_DEFINITIONS.SILENCE_RATE,
  excessive_hold_time: OUTLIER_DEFINITIONS.EXCESSIVE_HOLD_TIMES,
  invalid_agent_disconnect: OUTLIER_DEFINITIONS.ASSOCIATE_DISCONNECTS,
  invalid_transfer: OUTLIER_DEFINITIONS.INVALID_TRANSFERS,
  invalid_park: OUTLIER_DEFINITIONS.INVALID_PARK,
  excessive_hold_num: OUTLIER_DEFINITIONS.EXCESSIVE_HOLD_NUM,
  hold_time_rate: OUTLIER_DEFINITIONS.HOLD_TIME_RATE,
  ccx_bottom_twobox_twentyfive: OUTLIER_DEFINITIONS.CCX_BOTTOM_25,
  dart_usage: OUTLIER_DEFINITIONS.DART_USAGE,
  missed_followup: OUTLIER_DEFINITIONS.MISSED_FOLLOWUP,
  missed_contact: OUTLIER_DEFINITIONS.MISSED_CONTACT,
  dart_consult_effort: OUTLIER_DEFINITIONS.DART_CONSULT_EFFORT,
  invalid_concessions: OUTLIER_DEFINITIONS.INVALID_CONCESSIONS,
  missed_concessions: OUTLIER_DEFINITIONS.MISSED_CONCESSIONS,
  acht_bottom_ten: OUTLIER_DEFINITIONS.ACHT_BOTTOM_10,
  time_to_close: OUTLIER_DEFINITIONS.TIME_TO_CLOSE,
  spam_rate: OUTLIER_DEFINITIONS.SPAM_RATE,
  duplicate_rate: OUTLIER_DEFINITIONS.DUPLICATE_RATE,
  false_promise: OUTLIER_DEFINITIONS.FALSE_PROMISE,
} as const;

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
export const NUM_PAGES_BEFORE_SKIP_ARROW = 5;
export const MIN_NUM_PAGES_FOR_PAGINATION = 1;

export const OUTLIER_TM_INAPP_NOTIF_TITLE =
  'cs_perfportal_outlier_tm_reminder_inapp_title';
export const OUTLIER_TM_INAPP_NOTIF_MESSAGE =
  'cs_perfportal_outlier_tm_reminder_inapp_message';
export const OUTLIER_TM_EMAIL_TEMPLATE = 'OutlierTM_1';

export enum NotificationType {
  EMAIL = 'EMAIL',
  INAPP = 'INAPP',
}

export const ENABLE_SEND_REMINDER_BUTTON = () => {
  return !getCscEntityPrefix().includes('cn');
};
